import * as moment from 'moment';

const filters =
    [
        {
            name: "formatTime",
            execute: (value: any) => {
                var tempDate = new Date();
                var dateString = tempDate.toDateString();
                dateString = dateString + ' ' + value;
                var test = moment(dateString).format('hh:mm a');

                if (test == 'Invalid date')
                    return '';
                else
                    return test;
            }
        }
        , {
            name: "formatDate",
            execute: (date: any) => {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            }
        }
        , {
            name: "formatDateTime",
            execute: (date: any) => {
                if (!date) return null;

                var tempDate = date.substring(0, date.indexOf('T'));
                var tempTime = moment(date).format('hh:mm a');

                const [year, month, day] = tempDate.split('-');

                return `${month}/${day}/${year} ${tempTime}`;
            }
        }
    ]

export default filters


// WEBPACK FOOTER //
// ./ClientApp/src/filters/index.ts